import GQLFetch from './GQLFetch';

export default GQLFetch;
